import React from 'react';
import { LOCAL_STORAGE_PREFIX } from 'const';

function useStateWithLocalStorage_bool(localStorageKey, defaultValue = undefined) {
  const storedValue = localStorage.getItem(LOCAL_STORAGE_PREFIX + localStorageKey);
  let assignedValue = (storedValue === 'true');
  if (storedValue === null && defaultValue !== undefined)
   if (defaultValue === true)
    assignedValue = true;
   else if (defaultValue === false)
    assignedValue = false;

  const [value, setValue] = React.useState(assignedValue);

  React.useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_PREFIX + localStorageKey, value);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, setValue];
};

export default useStateWithLocalStorage_bool;